module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "OrderPage",
    attrs: {
      "id": "OrderPage"
    }
  }, [_c('header-component'), _vm._v(" "), _c('div', {
    directives: [{
      name: "prevent-back",
      rawName: "v-prevent-back.vue-router-disable",
      modifiers: {
        "vue-router-disable": true
      }
    }],
    staticClass: "g-bg-gray"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.isLoadFinish && _vm.isVoucherLoadFinish && _vm.isAccountFinishLoading) ? _c('div', {
    staticClass: "row"
  }, [(_vm.isOrderValid) ? _c('div', {
    staticClass: "col-lg-8 offset-lg-2 g-pt-70 g-pb-100",
    staticStyle: {
      "background-color": "white",
      "padding": "50px",
      "border-radius": "10px",
      "box-shadow": "0 4px 8px rgba(0, 0, 0, 0.1)"
    }
  }, [_c('br'), _vm._v(" "), _c('p', {
    staticClass: "page-title"
  }, [_vm._v("Order Page")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSubmitFail),
      expression: "isSubmitFail"
    }],
    staticClass: "alert alert-danger alert-dismissible fade show",
    attrs: {
      "id": "errorDivOrder",
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.isSubmitFail = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "alert-heading"
  }, [_vm._v("Attention!")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Please complete the form to proceed with the submission")])]), _vm._v(" "), (_vm.Order.ErrorMessage) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible fade show",
    attrs: {
      "id": "errorDivOrder",
      "role": "alert"
    }
  }, [_c('h4', {
    staticClass: "alert-heading"
  }, [_vm._v("Attention!")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.Order.ErrorMessage))])]) : _vm._e(), _vm._v(" "), (_vm.isThreshHoldShown) ? _c('div', {
    staticClass: "alert alert-warning alert-dismissible fade show",
    attrs: {
      "id": "errorDivOrder",
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.isThreshHoldShown = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "alert-heading"
  }, [_vm._v("Attention!")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("You have " + _vm._s(_vm.Capping.orderCap - _vm.Capping.orderCount) + " orders remaining on your account. After the number is reached you will no longer be able to place orders. For more information,\n                                          "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.ToggleHelpForm()
      }
    }
  }, [_vm._v("contact us")]), _vm._v(".")])]) : _vm._e(), _vm._v(" "), (_vm.isorderCapMet) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible fade show",
    attrs: {
      "id": "errorDivOrder",
      "role": "alert"
    }
  }, [_c('h4', {
    staticClass: "alert-heading"
  }, [_vm._v("Attention!")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("You have reached your order limit and are no longer able to submit any orders. For more information,\n                                          "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.ToggleHelpForm()
      }
    }
  }, [_vm._v("contact us")]), _vm._v(".")])]) : _vm._e(), _vm._v(" "), ((_vm.MasterAccountType == 'master') && _vm.$route.params.code) ? _c('div', {
    staticClass: "row div-spacing-top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters order-div"
  }, [(true) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [(true) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "order-confirmation-label"
  }, [_vm._v("Participant Name:")]), _vm._v(" "), (_vm.Account.accountType == 1) ? _c('span', {
    staticClass: "order-confirmation-description"
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.firstName) + " " + _vm._s(_vm.Account.primaryContact.lastName))]) : _c('span', {
    staticClass: "order-confirmation-description"
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.legalName))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "order-confirmation-label"
  }, [_vm._v("Participant Login Email:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confirmation-description"
  }, [_vm._v(_vm._s(_vm.Account.emailAddress))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "order-confirmation-label"
  }, [_vm._v("EVF ID:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confirmation-description"
  }, [_vm._v(_vm._s(_vm.Account.evfAccountNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "order-confirmation-label"
  }, [_vm._v("Salesforce ID:")]), _vm._v(" "), _c('a', {
    staticClass: "order-confirmation-description",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.Account.salesforceId))])])])]) : _vm._e()]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.MasterAccountType == 'master' && !_vm.$route.params.code) ? _c('participant-account-information', {
    attrs: {
      "Order": _vm.Order
    },
    on: {
      "search": _vm.AccountValue
    }
  }) : _vm._e(), _vm._v(" "), _c('general-information', {
    attrs: {
      "Order": _vm.Order,
      "Account": _vm.Account,
      "Voucher": _vm.Voucher,
      "State": _vm.State,
      "ReferralOrgSelect": _vm.ReferralOrgSelect,
      "VoucherList": _vm.VoucherList,
      "Suffix": _vm.Suffix,
      "ValidationResult": _vm.ValidationResult
    }
  }), _vm._v(" "), (!_vm.MasterAccountType && _vm.$route.params.EditOrReuse != 1) ? _c('patient-information', {
    ref: "patient",
    attrs: {
      "Order": _vm.Order,
      "Ethnicity": _vm.Ethnicity,
      "ValidationResult": _vm.ValidationResult
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.Order.IsExamOnly) ? _c('order-information', {
    attrs: {
      "Order": _vm.Order,
      "ValidationResult": _vm.ValidationResult,
      "MasterAccountType": _vm.MasterAccountType,
      "PrismDirection": _vm.PrismDirection
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.Order.IsExamOnly) ? _c('frame-information', {
    attrs: {
      "Order": _vm.Order,
      "ValidationResult": _vm.ValidationResult,
      "Capping": _vm.Capping,
      "MasterAccountType": _vm.MasterAccountType,
      "isFrameLensServiceFee": _vm.Account.isFrameLensServiceFee,
      "Account": _vm.Account
    },
    on: {
      "help": function($event) {
        return _vm.ToggleHelpForm()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('additional-information', {
    attrs: {
      "Order": _vm.Order,
      "Account": _vm.Account,
      "State": _vm.State,
      "MasterAccountType": _vm.MasterAccountType,
      "ValidationResult": _vm.ValidationResult
    }
  }), _vm._v(" "), (!_vm.isorderCapMet && _vm.MasterAccountType != 'master' && _vm.Account.isStandardOrderServiceFee && _vm.Order.JobType != 'LSF') ? _c('p', {
    staticClass: "order-payment",
    staticStyle: {
      "background-color": "#d5e4ef7a"
    }
  }, [_vm._v("Please note: After you submit, you will be charged a service fee for this order.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row  text-center"
  }, [(!_vm.Order.IsExamOnly) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 g-mt-15"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-font-size-18",
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('true', 'false', 'true')
      }
    }
  }, [_vm._v("Save as Pending Order")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 g-mt-15",
    class: {
      'col-lg-6 col-md-6': !_vm.Order.IsExamOnly, 'col-md-12 col-lg-12': _vm.Order.IsExamOnly
    }
  }, [(!_vm.Order.IsExamOnly && !_vm.Order.DoesNotMeetRequirements && _vm.AccountStatus != 'OrderHoldUnderReview' && !_vm.isorderCapMet && ((_vm.Capping.frameLensCount < _vm.Capping.frameLensCap && _vm.Order.JobType == 'LSF') || !_vm.Capping.isFrameLensCapOn)) ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('false', 'false', 'true', 'false')
      }
    }
  }, [_vm._v("Review and Submit Order")]) : (_vm.Order.IsExamOnly) ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitExamOnlyOrder()
      }
    }
  }, [_vm._v("Save")]) : (_vm.AccountStatus != 'OrderHoldUnderReview' && _vm.isorderCapMet) ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button",
      "disabled": true
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('false', 'false', 'true', 'false')
      }
    }
  }, [_vm._v("Review and Submit Order")]) : (_vm.AccountStatus != 'OrderHoldUnderReview' && _vm.isorderCapMet && _vm.MasterAccountType == 'master') ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('false', 'false', 'true', 'false')
      }
    }
  }, [_vm._v("Review and Submit Order")]) : (_vm.AccountStatus != 'OrderHoldUnderReview' && _vm.Order.JobType == 'LSF' && (_vm.Capping.frameLensCount >= _vm.Capping.frameLensCap) && _vm.MasterAccountType != 'master' && _vm.Capping.isFrameLensCapOn) ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button",
      "disabled": true
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('false', 'false', 'true', 'false')
      }
    }
  }, [_vm._v("Review and Submit Order")]) : (_vm.AccountStatus != 'OrderHoldUnderReview' && _vm.Order.JobType == 'LSF' && (_vm.Capping.frameLensCount < _vm.Capping.frameLensCap) && _vm.MasterAccountType == 'master') ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('false', 'false', 'true', 'false')
      }
    }
  }, [_vm._v("Review and Submit Order")]) : ((!_vm.Order.DoesNotMeetRequirements && _vm.AccountStatus == 'OrderHoldUnderReview') || (_vm.Order.DoesNotMeetRequirements && _vm.AccountStatus == 'OrderHoldUnderReview')) ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button",
      "disabled": true
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('false', 'false', 'true', 'false')
      }
    }
  }, [_vm._v("Review and Submit Order")]) : (_vm.Order.DoesNotMeetRequirements == true && _vm.MasterAccountType == 'master' && _vm.$route.params.code && this.$route.params.EditOrReuse != 1) ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('true', 'true', 'false', 'true')
      }
    }
  }, [_vm._v("Approve Special Order")]) : (_vm.Order.DoesNotMeetRequirements == true && _vm.MasterAccountType == 'master' && _vm.$route.params.code && this.$route.params.EditOrReuse == 1) ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('true', 'true', 'false', 'true')
      }
    }
  }, [_vm._v("Submit Special Order")]) : (_vm.Order.DoesNotMeetRequirements == true && _vm.MasterAccountType != 'master') ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('false', 'false', 'true', 'false')
      }
    }
  }, [_vm._v("Review and Submit for Approval")]) : (_vm.Order.DoesNotMeetRequirements == true && _vm.MasterAccountType != 'master') ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('false', 'false', 'true', 'false')
      }
    }
  }, [_vm._v("Review and Submit for Approval")]) : _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('false', 'false', 'true', 'false')
      }
    }
  }, [_vm._v("Review and Submit Order")])])])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isOrderValid) ? _c('div', {
    staticClass: "col-lg-8 offset-lg-2 g-pt-70 g-pb-100"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.isModalReviewShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog order-modal-size"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('order-review', {
    attrs: {
      "OrderReturn": _vm.OrderReturn,
      "Account": _vm.Account,
      "Voucher": _vm.Voucher
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 g-my-20"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-btn-130",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("Edit")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center"
  }, [(!_vm.Order.DoesNotMeetRequirements) ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-btn-130",
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('true', 'true', 'false', 'false')
      }
    }
  }, [_vm._v("Submit Order")]) : _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-btn-130",
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('true', 'true', 'false', 'false')
      }
    }
  }, [_vm._v("Submit Order")])])])])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isSaveChangesModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseSaveChangesModal('stay')
      }
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center g-pb-10"
  }, [_c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-btn-130",
    on: {
      "click": function($event) {
        return _vm.CloseSaveChangesModal('leave')
      }
    }
  }, [_vm._v("Leave this page")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-btn-130",
    on: {
      "click": function($event) {
        return _vm.CloseSaveChangesModal('stay')
      }
    }
  }, [_vm._v("Stay on this page")])])])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isLoadFinish || !_vm.isVoucherLoadFinish || !_vm.isAccountFinishLoading) ? _c('div', {
    staticClass: "row g-pt-100"
  }, [_c('page-loader')], 1) : _vm._e(), _vm._v(" "), (_vm.isSubmitFinish) ? _c('loading-component') : _vm._e()], 1)]), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n          Participant Account Information\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("Error!")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n                                          Order requested is not valid.\n                                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "passwordReset-header"
  }, [_c('p', {
    staticClass: "order-review-page-title"
  }, [_vm._v("Order Review")]), _vm._v(" "), _c('p', {
    staticClass: "order-review-description",
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("Please review and confirm your order details before submitting.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 g-mt-30 g-mb-30"
  }, [_c('h5', [_vm._v("\n                                                                  Are you sure you want to leave this page? Your order information will not be saved.  To save the info, please select “Save as Pending Order” at the bottom of the page.\n                                                                  ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7d935bee", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d935bee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/Order/Order.vue
// module id = 548
// module chunks = 4